import { combineReducers } from "redux";
import vehiclesReducer from "./vehicleReducer";
import metricsReducer from "./metricsReducer";
import routeReducer from "./routeReducer";
import popupReducer from "./popupReducer";

const rootReducer = combineReducers({
  vehicle: vehiclesReducer,
  metrics: metricsReducer,
  vehicleRoutes: routeReducer,
  popupView: popupReducer,
});

export default rootReducer;

//export type State = ReturnType<typeof rootReducer>;
